import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import * as api from "../api"

export const getNotifications = createAsyncThunk("get-notifications", async () => {
    const response = await api.getNotifications()
    return response
})

const notificationSlice = createSlice({
    name: "notification",
    initialState: {
        data: [],
        fetchStatus: "",
        action: ""
    },
    reducers: {
        updateNotification(state, action) {
            const { field, value } = action.payload
            state.notification = { ...state.notification, [field]: value }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getNotifications.fulfilled, (state, action) => {
                state.data = action.payload?.records
                state.fetchStatus = "success"
                state.action = "getNotifications"
            })
            .addCase(getNotifications.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getNotifications"
            })
            .addCase(getNotifications.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getNotifications"
            })
    }
})

export default notificationSlice
export const { updateNotification } = notificationSlice
